import { HTTPClient } from './http-client';
import { createMarketdataAPI } from './modules';
import { createPnlAttributionsAPI } from './modules';
import { createMarketSummaryAPI } from './modules';
import { createAccountAPI } from './modules/account';
import { createAttributionsAPI } from './modules/attributions/attributions.api';
import { createAuditAPI } from './modules/audit/audit.api';
import { createBatchExecutorAPI } from './modules/batch-executor';
import { createBondsRecAPI } from './modules/bonds-rec/bonds-rec.api';
import { createBucketsAPI } from './modules/buckets/buckets.api';
import { createClientPricingAPI } from './modules/client-pricing/client-pricing.api';
import { createDataUploadAPI } from './modules/data-upload/data-upload.api';
import { createExternalAPI } from './modules/external/external.api';
import { createFactsheetsAPI } from './modules/factsheets/factsheets.api';
import { createFeedsAPI } from './modules/feeds';
import { createFlowsAPI } from './modules/flows/flows.api';
import { createFundsAPI } from './modules/funds';
import { createHedgingAPI } from './modules/hedging/nt-hedging-fxfwd.api';
import { createICGuidelinesAPI } from './modules/ic-guidelines';
import { createICReportAPI } from './modules/ic-report';
import { createInstrumentsAPI } from './modules/instruments/instruments.api';
import { createLogsAPI } from './modules/logs';
import { createManagementReportAPI } from './modules/management-report/management-report.api';
import { createMiscAPI } from './modules/misc/misc.api';
import { createMonthlyRollAPI } from './modules/monthly-roll';
import { createPosmonAPI } from './modules/posmon/posmon.api';
import { createPremialabAPI } from './modules/premialab/premialab.api';
import { createPricesAPI } from './modules/prices/prices.api';
import { createPricingInterfaceAPI } from './modules/pricing-interface/pricing-interface.api';
import { createRFQAPI } from './modules/rfq/rfq.api';
import { createSalesAPI } from './modules/sales/sales.api';
import { createShareclassesAPI } from './modules/shareclasses/shareclasses.api';
import { createSmartradeAPI } from './modules/smartrade/smartrade.api';
import { createSwapaggAPI } from './modules/swapagg';
import { createTradesAPI } from './modules/trades/trades.api';
import { createTxReportingAPI } from './modules/tx-reporting/tx-reporting.api';
import { createUploadTrackAPI } from './modules/upload-track/upload-track.api';
import { createWebsiteAPI } from './modules/website/website.api';
import { createStreamClient } from './stream-client';
export const createApi = ({ baseUrl, getToken, defaultOptions, httpClient = new HTTPClient({ baseUrl, getToken, defaultOptions }), streamClient = createStreamClient({ baseUrl, getToken }), }) => {
    const transports = {
        http: httpClient,
        streaming: streamClient,
    };
    return {
        account: createAccountAPI(transports),
        feeds: createFeedsAPI(transports),
        funds: createFundsAPI(transports),
        icGuidelines: createICGuidelinesAPI(transports),
        icReport: createICReportAPI(transports),
        logs: createLogsAPI(transports),
        monthlyRoll: createMonthlyRollAPI(transports),
        swapagg: createSwapaggAPI(transports),
        trades: createTradesAPI(transports),
        batchExecutor: createBatchExecutorAPI(transports),
        instruments: createInstrumentsAPI(transports),
        buckets: createBucketsAPI(transports),
        misc: createMiscAPI(transports),
        rfq: createRFQAPI(transports),
        txReporting: createTxReportingAPI(transports),
        prices: createPricesAPI(transports),
        hedging: createHedgingAPI(transports),
        sales: createSalesAPI(transports),
        external: createExternalAPI(transports),
        bondsRec: createBondsRecAPI(transports),
        dataUpload: createDataUploadAPI(transports),
        smartrade: createSmartradeAPI(transports),
        pm: createSmartradeAPI(transports),
        attributions: createAttributionsAPI(transports),
        premialab: createPremialabAPI(transports),
        uploadTrack: createUploadTrackAPI(transports),
        posmon: createPosmonAPI(transports),
        website: createWebsiteAPI(transports),
        pricingInterface: createPricingInterfaceAPI(transports),
        factsheets: createFactsheetsAPI(transports),
        shareclasses: createShareclassesAPI(transports),
        clientPricing: createClientPricingAPI(transports),
        audit: createAuditAPI(transports),
        managementReport: createManagementReportAPI(transports),
        flows: createFlowsAPI(transports),
        marketdata: createMarketdataAPI(transports),
        pnlAttributions: createPnlAttributionsAPI(transports),
        marketSummary: createMarketSummaryAPI(transports),
    };
};
